import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPause = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.75 11.25V0.75H11.25V11.25H7.75ZM0.75 11.25V0.75H4.25V11.25H0.75Z",
		fill: "#E3E3E3"
	})
});
export default SvgPause;
